import { useState, useEffect } from "react";

const usePendingPayment = () => {
  const [pendingPayment, setPendingPayment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPendingPayment = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch(`https://urchin-app-vijhz-lvk4i.ondigitalocean.app/api/v1/organization/subscription/pending-payment-transaction`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        if (response.status === 404) {
          // No pending payment found
          setPendingPayment(null);
          return;
        }
        throw new Error('Failed to fetch pending payment details');
      }

      const data = await response.json();
      setPendingPayment(data);
    } catch (err) {
      setError(err.message);
      setPendingPayment(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingPayment();
  }, []);

  const refetch = () => {
    fetchPendingPayment();
  };

  return {
    pendingPayment,
    loading,
    error,
    refetch
  };
};

export default usePendingPayment; 